import useTranslation from 'next-translate/useTranslation';

const COPYRIGHT_URL = 'https://api.mapy.cz/copyright';

/**
 * In order to use mapy.cz API attribution rules need to be followed
 *
 * @see https://developer.mapy.cz/rest-api/atributovani/
 */
export const SeznamAttribution = () => {
    const { t } = useTranslation();

    return (
        <a className="text-tiny no-underline" href={COPYRIGHT_URL} rel="noreferrer" target="_blank">
            {t('© Seznam.cz a.s. and others')}
        </a>
    );
};
